import { css, Theme } from '@emotion/react'

import { pxToRem } from '../theme'
import { getLinkStyle } from './link'

const spacedElements = 'p, ol, ul, h1, h2, h3, h4, h5, h6'

export const getMooncakeContentStyle = (theme: Theme) => css`
  ${theme.typography.body};
  color: ${theme.colors.secondaryLabel};
  margin-top: ${theme.spacing.m};
  margin-bottom: ${theme.spacing.m};

  a[href] {
    ${getLinkStyle(theme)};
  }

  img {
    max-width: 100%;
  }

  ol,
  ul {
    padding-left: ${theme.spacing.l};
    list-style-position: outside;
  }

  ol {
    list-style-type: decimal;
  }

  ul {
    list-style-type: disc;
  }

  *:is(${spacedElements}) {
    margin: ${theme.spacing.m} ${theme.spacing.empty};
  }

  table *:is(${spacedElements}):first-of-type {
    margin-top: 0;
  }

  table *:is(${spacedElements}):last-child {
    margin-bottom: 0;
  }

  th,
  td {
    text-align: left;
    vertical-align: top;
    padding: ${theme.spacing.xs};
    border: 1px solid ${theme.colors.hairline};
  }

  th {
    color: ${theme.colors.secondaryLabel};
    background: ${theme.colors.secondaryBackground};
    font-weight: ${theme.weights.medium}; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
  }
`

export const getArcadeContentStyle = (theme: Theme) => css`
  ${theme.typography.body};
  color: ${theme.arcadeColors.semantic.textSubtle};
  margin-top: ${theme.spacing.m};
  margin-bottom: ${theme.spacing.m};

  a[href] {
    ${getLinkStyle(theme)};
  }

  img {
    max-width: 100%;
  }

  ol,
  ul {
    padding-left: ${theme.spacing.l};
    list-style-position: outside;
  }

  ol {
    list-style-type: decimal;
  }

  ul {
    list-style-type: disc;
  }

  *:is(${spacedElements}) {
    margin: ${theme.spacing.m} ${theme.spacing.empty};
  }

  table *:is(${spacedElements}):first-of-type {
    margin-top: 0;
  }

  table *:is(${spacedElements}):last-child {
    margin-bottom: 0;
  }

  th,
  td {
    text-align: left;
    vertical-align: top;
    padding: ${theme.spacing.xs};
    border: ${pxToRem(1)} solid ${theme.arcadeColors.semantic.borderDivider};
  }

  th {
    color: ${theme.arcadeColors.semantic.textStandard};
    background: ${theme.arcadeColors.semantic.backgroundSubtle};
    font-weight: ${theme.weights.medium}; /* stylelint-disable-line @cash-web/no-hardcoded-font-styles */
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6,
  details {
    color: ${theme.arcadeColors.semantic.textStandard};
  }

  hr {
    color: ${theme.arcadeColors.component.uiDividerBorder};
  }
`
